import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IndividualUserInjection } from "features/individualUsersManagement/di/IndividualUserInjection";
import { injectable } from "tsyringe";
import { IndividualUserRequestEntity } from "../entities/IndividualUserRequestEntity";
import { IndividualUserResponseEntity } from "../entities/IndividualUserResponseEntity";
import { IIndividualUserRepository } from "../repositories/IIndividualUserRepository";

@injectable()
export class IndividualUserUseCase {
  private individualUserRepo: IIndividualUserRepository;

  constructor() {
    this.individualUserRepo = IndividualUserInjection.getRepo();
  }

  private checkParams(params: IndividualUserRequestEntity): IndividualUserRequestEntity {
    return {
      ...params,
      code: params.code || undefined,
      phone: params.phone || undefined,
      status: params.status !== undefined ? params.status : undefined,
    };
  }

  async getIndividualUsers(
    params: IndividualUserRequestEntity,
  ): Promise<ListBaseApiResponseModel<IndividualUserResponseEntity>> {
    return await this.individualUserRepo.getList(this.checkParams(params));
  }

  async getIndividualUserDetail(
    phone: string,
  ): Promise<BaseApiResponseModel<IndividualUserResponseEntity>> {
    return await this.individualUserRepo.getDetail({ phone });
  }

  async resetOtpUser(
    phone: string,
  ): Promise<BaseApiResponseModel<{ phone?: string; deleteOtpCount?: number }>> {
    return await this.individualUserRepo.resetOtpUser(phone);
  }
}
